import { useState, useEffect, useRef, useCallback } from "react";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";

const UsersTable = ({ users, setUsers, refreshUsers, visibilityFilter }) => {
  const [editedRow, setEditedRow] = useState(NaN);
  const [isEdit, setEdit] = useState(false);
  const [editedColumn, setEditedColumn] = useState("");
  const [editedData, setEditedData] = useState("");
  const [isUserAdding, setUserAdding] = useState(false);
  const [newUser, setNewUser] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  async function addUser() {
    setUserAdding(false);
    const { name, email, status = 2, pass } = newUser;
    if (!name) {
      alert("Не введено имя");
      return;
    }
    if (!email) {
      alert("Не введен email");
      return;
    }
    if (!pass) {
      alert("Не введен пароль");
      return;
    }
    setNewUser({});
    const updated = [...users, { name, email, status }];
    setUsers(updated);
    const user = {
      name: name?.trim(),
      email: email?.trim(),
      status,
      pass: pass?.trim(),
    };
    api.post(E.ADD_USER, 4, { user });
  }

  const inputRef = useRef(null);

  const statuses = ["уволен", "клиент", "юзер", "модер", "админ"];
  const getStatusName = (ind) => {
    return statuses[ind] || "неизвестно";
  };

  const updDbUser = useCallback((key, user) => {
    let endpoint = null;
    if (key === "name") endpoint = E.RENAME_USER;
    if (key === "status") endpoint = E.CHANGE_USER_STATUS;
    if (key === "pass") endpoint = E.CHANGE_USER_PASS;
    if (key === "mti") endpoint = E.CHANGE_USER_MTI;
    if (!endpoint) return;

    api.post(endpoint, 4, { user }).then(res => refreshUsers());
  }, [refreshUsers]);

  function resetEdition() {
    setEditedRow(NaN);
    setEditedColumn("");
    setEdit(false);
    setEditedData("");
  }

  const updateUser = useCallback(() => {
    const user = filteredData[editedRow];
    user[editedColumn] = editedColumn !== "status" ? editedData : +editedData;
    updDbUser(editedColumn, user);
  }, [editedColumn, editedData, editedRow, filteredData, updDbUser]);

  const editHandler = useCallback(
    (ind, key, e) => {
      if (e && e.target.tagName === "INPUT") {
        return;
      }

      if (!isEdit) {
        setEditedRow(ind);
        setEditedColumn(key);
        setEdit(true);
        setEditedData(users[ind][key]);
      } else {
        updateUser();
        resetEdition();
      }
    },
    [isEdit, users, updateUser]
  );

  const handleStatusChange = useCallback(
    (ind, newStatus) => {
      const user = filteredData[ind];
      user.status = +newStatus;
      updDbUser("status", user);
    },
    [filteredData, updDbUser]
  );

  useEffect(() => {
    if (inputRef.current && isEdit) {
      inputRef.current.focus();
    }
  }, [isEdit, editedRow, editedColumn]);

  const handleInputChange = (e) => {
    setEditedData(e.target.value);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      editHandler(editedRow, editedColumn);
    } else if (e.key === "Escape") {
      resetEdition();
    }
  };

  const handleInputBlur = () => {
    if (isEdit) {
      editHandler(editedRow, editedColumn);
    }
  };

  const isCurrentEdit = (ind, key) => {
    if (!isEdit) return false;
    return ind === editedRow && key === editedColumn;
  };

  async function changeMTI(val, ind) {
    const user = filteredData[ind];
    user.moderator = val;
    updDbUser("mti", user);
  }

  useEffect(() => {
    switch (visibilityFilter) {
      case "users":
        setFilteredData(users.filter((i) => isNaN(+i.name)));
        break;
      case "clients":
        setFilteredData(users.filter((i) => !isNaN(+i.name)));
        break;
      default:
        setFilteredData(users);
        break;
    }
  }, [visibilityFilter, setFilteredData, users]);

  return (
    <>
      <div className="admin_table-container">
        <table className="admin_config-table">
          <thead className="admin_config-table">
            <tr>
              <th>Имя</th>
              <th>E-mail</th>
              <th>
                МВР&nbsp;
                <span
                  style={{ cursor: "pointer" }}
                  title="Модератор на Вокер.ру(про)"
                >
                  ?
                </span>
              </th>
              <th>Роль</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="admin_config-table admin_users-table">
            {filteredData.map((item, ind) => (
              <tr key={`user-${ind}`}>
                <td onClick={(e) => editHandler(ind, "name", e)}>
                  {isCurrentEdit(ind, "name") ? (
                    <input
                      ref={inputRef}
                      type="text"
                      value={editedData}
                      onChange={handleInputChange}
                      onKeyDown={handleInputKeyDown}
                      onBlur={handleInputBlur}
                      onClick={(e) => e.stopPropagation()}
                    />
                  ) : (
                    <span>{item.name}</span>
                  )}
                </td>
                <td>
                  <span>{item.email}</span>
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={item.moderator}
                    onChange={(e) => changeMTI(e.target.checked, ind)}
                  />
                </td>
                <td>
                  <select
                    value={item.status}
                    onChange={(e) => {
                      handleStatusChange(ind, e.target.value);
                    }}
                  >
                    <option value="0">{getStatusName(0)}</option>
                    <option value="1">{getStatusName(1)}</option>
                    <option value="2">{getStatusName(2)}</option>
                    <option value="3">{getStatusName(3)}</option>
                    <option value="4">{getStatusName(4)}</option>
                  </select>
                </td>
                <td>
                  {isCurrentEdit(ind, "pass") ? (
                    <input
                      ref={inputRef}
                      type="text"
                      value={editedData}
                      onChange={handleInputChange}
                      onKeyDown={handleInputKeyDown}
                      onBlur={handleInputBlur}
                      onClick={(e) => e.stopPropagation()}
                    />
                  ) : (
                    <button onClick={(e) => editHandler(ind, "pass", e)}>
                      Задать пароль
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {isUserAdding ? (
          <div className="add_user_block">
            <div className="input_block select_block">
              <strong>Имя</strong>
              <input
                className="add-user-input"
                type="text"
                value={newUser.name}
                onChange={(e) =>
                  setNewUser((prev) => ({ ...prev, name: e.target.value }))
                }
              />
            </div>
            <div className="input_block select_block">
              <strong>Email</strong>
              <input
                className="add-user-input"
                type="text"
                value={newUser.email}
                onChange={(e) =>
                  setNewUser((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </div>
            <div className="input_block select_block">
              <strong>Роль</strong>
              <select
                value={newUser.status || "2"}
                onChange={(e) =>
                  setNewUser((prev) => ({ ...prev, status: +e.target.value }))
                }
              >
                <option value="0">{getStatusName(0)}</option>
                <option value="1">{getStatusName(1)}</option>
                <option value="2">{getStatusName(2)}</option>
                <option value="3">{getStatusName(3)}</option>
                <option value="4">{getStatusName(4)}</option>
              </select>
            </div>
            <div className="input_block select_block">
              <strong>Пароль</strong>
              <input
                className="add-user-input"
                type="text"
                value={newUser.pass}
                onChange={(e) =>
                  setNewUser((prev) => ({ ...prev, pass: e.target.value }))
                }
              />
            </div>
          </div>
        ) : null}
        <button
          onClick={() => {
            !isUserAdding ? setUserAdding(true) : addUser();
          }}
        >
          {!isUserAdding ? "Добавить пользователя >" : "Сохранить в БД >"}
        </button>
      </div>
    </>
  );
};

export default UsersTable;
